import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./TemplatesIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./TemplatesList'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./TemplatesFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const FolderContent = Loadable({
  loader: () => import('./TemplateFolderContent'),
  loading: () => <Loading withContentWrapper />,
});

export const FolderForm = Loadable({
  loader: () => import('./TemplateFolderFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Automation = Loadable({
  loader: () => import('./TemplatesAutomationPage'),
  loading: () => <Loading withContentWrapper />,
});

export const TemplatePropertyForm = Loadable({
  loader: () => import('./TemplatesPropertyFormPage'),
  loading: () => <Loading withContentWrapper />,
});
